export const END_CAMPAIGN_BODY = 'This will permanently end the Drip Campaign';
